/**
 * Sticky offset/z for section titles without the nested rail join.
 * Prefer StickySectionHeading when rendering headings.
 */
export function stickySectionHeadingClass(level: number, underline = true): string {
  const top = level <= 0 ? 'top-24' : 'top-36';
  const z = level <= 0 ? 'z-20' : 'z-10';
  const border = underline ? 'border-b border-gray-200' : '';
  return `sticky ${top} ${z} bg-white py-2 ${border}`.trim();
}
